import React from "react";
import _ from "lodash/fp";
import chevronUpSmall from "@ingka/ssr-icon/paths/chevron-up-small";
import chevronDownSmall from "@ingka/ssr-icon/paths/chevron-down-small";
import Button from "@ingka/button";

type Props = {
	ariaLabel?: string;
	onClick?: () => void;
	isCollapsed?: boolean;
	title?: string;
	ariaControls?: string;
};

const CollapseButton: React.FunctionComponent<Props> = ({
	ariaLabel = "Collapse or expand section",
	isCollapsed = false,
	onClick = _.noop,
	title,
	ariaControls,
}) => {
	return (
		<Button
			text={title}
			onClick={onClick}
			type="tertiary"
			size="small"
			iconOnly
			ssrIcon={isCollapsed ? chevronDownSmall : chevronUpSmall}
			aria-label={ariaLabel}
			aria-expanded={!isCollapsed}
			aria-controls={ariaControls}
		/>
	);
};

export default CollapseButton;
